import React from "react";
import { View, Pressable, Alert, Platform } from "react-native";
import LoadingView from "../components/common/loading-view";
import { ErrorDisplay } from "../components/common/error-display";
import { useActiveAgent } from "../contexts/ActiveAgentContext";
import StyledText from "../components/common/ui/styled-text";
import LomanRobot from "../components/common/loman-robot";

export function useAgentsStatus() {
  const { agentsLoading, agentsError, hasNoAgents } = useActiveAgent();

  const isMobile = Platform.OS !== "web";

  if (agentsLoading) {
    return <LoadingView />;
  }

  if (agentsError) {
    return <ErrorDisplay message={agentsError.message} />;
  }

  if (hasNoAgents) {
    return (
      <View className="bg-white flex flex-1 items-center px-4">
        <View className="bg-white flex flex-1 items-center justify-center">
          <View className="p-1">
            <LomanRobot size={56} color="black" />
          </View>
          <StyledText className="font-medium mb-4">
            You don't have any agents yet.
          </StyledText>
          <Pressable
            className="bg-gray-900 px-4 py-2 rounded-md"
            onPress={() => {
              if (isMobile) {
                Alert.alert(
                  "Create Agent",
                  "Please contact the team to create an agent.",
                  [{ text: "OK" }]
                );
              } else {
                window.alert("Please contact the team to create an agent.");
              }
            }}
          >
            <StyledText className="font-medium text-white">
              Create an agent
            </StyledText>
          </Pressable>
        </View>
      </View>
    );
  }

  return null;
}
